import * as React from 'react'
import {Fragment} from 'react'
import {observer} from 'mobx-react'
import {EpikQueryParam, PaymentMethod, TransactionStatus} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {WidgetFlag} from '../../../../lib/WidgetFlag'
import {WidgetView} from '../../../../lib/WidgetView'
import {TransactionInfo} from '../elements/TransactionInfo'
import {Faq} from '../../common/elements/Faq'
import {PaymentInfoStatus} from '../../common/elements/PaymentInfoStatus'
import {PaymentDownloadPdf} from '../../common/elements/PaymentDownloadPdf'
import {MPoSInitialization} from '../../common/elements/MPoSInitialization'
import {RetryPayment} from '../../common/elements/RetryPayment'
import {FooterInfo} from '../../common/elements/FooterInfo'
import {TransactionNotFoundBlock} from './TransactionNotFoundBlock'

///////////////////////////////////////////////////////////////////////////////

export const TransactionInfoBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  let finalStatus = null
  let showStatus = false
  let showInfo = false
  let isSuccess = false
  let isPending = false
  let isMpos = false
  let showMPoSInitialization = false
  const showRetryPaymentButton = api.resolveConfigWithSingleResult<boolean>(
    'showRetryPaymentButton',
  )
  const paymentType = !!api.subscriptionInfo ? 'subscription' : 'payment'

  if (api.flags.has(WidgetFlag.TRANSACTION_NOT_FOUND)) {
    return <TransactionNotFoundBlock />
  }

  if (api.flags.has(WidgetFlag.PAYMENT_ABORTED)) {
    finalStatus = TransactionStatus.ERROR
    showStatus = true
  } else if (api.flags.has(WidgetFlag.HAS_TRANSACTION_INFO)) {
    finalStatus = api.getTransactionFinalStatus()

    if (!finalStatus) {
      return null
    }

    isSuccess = finalStatus === TransactionStatus.SUCCESS
    isPending = finalStatus === TransactionStatus.PENDING

    isMpos =
      api.transactionInfo &&
      api.transactionInfo.payment_method === PaymentMethod.MPOS
    showMPoSInitialization = isPending && isMpos

    if (isSuccess) {
      showStatus =
        api.currentLocation.params[EpikQueryParam.VIEW] ===
        WidgetView.PAYMENT_RESULT
      showInfo = true
    } else {
      showStatus = true
    }
  } else {
    return null
  }

  return (
    <div className="widget-block transaction-info-block">
      {isSuccess && !showStatus && (
        <div className="widget-block-header">
          <div className="title">
            <h2 className="text">
              {api.trans('blocks.transaction_info.title')}
            </h2>
          </div>
        </div>
      )}

      <div className="widget-block-content">
        {showMPoSInitialization && <MPoSInitialization />}
        {showStatus && (
          <PaymentInfoStatus
            paymentType={paymentType}
            finalStatus={finalStatus}
          />
        )}

        {showInfo && (
          <Fragment>
            <PaymentDownloadPdf />
            <TransactionInfo />
            <Faq />
            {showRetryPaymentButton && (
              <RetryPayment
                text={api.trans('blocks.transaction_info.retry_payment')}
                className="retry-payment-line"
              />
            )}
          </Fragment>
        )}
      </div>
      <FooterInfo />
    </div>
  )
})
